
export default {
    // path: 'http://192.168.88.41:8099/newswjnoffcial',   //hxf 税务技能官网
    // path: 'http://192.168.88.119:8099/newswjnoffcial/',   //董杰

    /** 测试 */
    // iconPath: 'http://testresource.caidao8.com',   //图片地址
    // path: 'http://gsjsadmin1.gssrz.com/teacherswjnoffcial/',

    /** 正式 */
    iconPath: 'http://resource.caidao8.com',   //图片地址
    //原先的路径
    // path: "http://gsjsadmin.gssrz.com/newswjnoffcial/",
     path: "http://gsjsadmin.gssrz.com/teacherswjnoffcial/",
    minute: 30,     //cookie过期时间 分钟
    /**
     * 设置cookie
     * @param {*} name 
     * @param {*} value 
     */
    setCookie: function (name, value, path) {
        var exp = new Date();
        exp.setTime(exp.getTime() + this.minute * 60 * 1000);
        if (path) {
            document.cookie = name + "=" + escape(value) + ";path=" + path + ";expires=" + exp.toGMTString();
        } else {
            document.cookie = name + "=" + escape(value) + ";expires=" + exp.toGMTString();
        }
    },

    /**
     * 读取cookie
     * @param {*} name 
     */
    getCookie: function (name) {
        var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
        if (arr = document.cookie.match(reg))
            return unescape(arr[2]);
        else
            return null;
    },

    /**
     * 删除cookie
     * @param {*} name 
     */
    delCookie: function (name) {
        var exp = new Date();
        // exp.setTime(exp.getTime() - 1);    //过期时间
        exp.setTime(-1000);//设置时间
        var cval = this.getCookie(name);
        if (cval != null)
            document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
    },

    /**
     * 删除全部cookie
     */
    delAllCookie: function () {
        var exp = new Date();
        exp.setTime(-1000);    //过期时间
        var data = document.cookie;
        var dataArray = data.split('; ')
        for (let i = 0; i < dataArray.length; i++) {
            var varName = dataArray[i].split("=");
            if (varName[0] != "undefind") {
                document.cookie = varName[0] + "=''" + ";expires=" + exp.toGMTString();
            }
        }

    },

    //读取全部cookie
    readCookie(cookie) {
        var exp = new Date();
        exp.setTime(exp.getTime() + this.minute * 60 * 1000);
        var dataArray = cookie.split('; ')
        for (let i = 0; i < dataArray.length; i++) {
            var varName = dataArray[i].split("=");
            document.cookie = varName[0] + "=" + varName[1] + ";expires=" + exp.toGMTString();
        }
    },
}


// WEBPACK FOOTER //
// ./src/tools/common.js